import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

import { useMember } from 'lib/hooks/queries/member/useMember';

import InviteMemberModal from 'components/Staff/components/InviteMemberModal';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import HeaderActions from '../HeaderActions';

import { getDefaultColumns } from './lib/helpers';

const WizardStaff = ({
  updateConfigs,
  mutateOrchestratorData,
  setHeaderButtonProps,
  onPrev,
  orchestratorLoading,
  wizardState
}) => {
  const { practice } = useOutletContext();
  const principalUserId = wizardState?.instance?.assigned_to;
  useEffect(() => {
    updateConfigs({
      message: 'Please fill out required data in the form',
      goBackHandler: onPrev,
      actions: [
        {
          text: 'Continue',
          onClick: async () => mutateOrchestratorData(),
          isDisabled: orchestratorLoading
        }
      ]
    });
  }, [orchestratorLoading]);

  return (
    <div className="mb-4 flex flex-1 flex-col">
      <AgTablePage
        defaultColumns={getDefaultColumns(principalUserId)}
        defaultFilters={[]}
        useData={useMember}
        title="Staff"
        name="members"
        noHeader
        actions={(props) => (
          <HeaderActions {...props} setMotionHeaderButtonProps={setHeaderButtonProps} />
        )}
        rowStyle={{ cursor: 'pointer' }}
        queryParams={{ practiceId: practice?.id }}
        ModalComponent={InviteMemberModal}
        autoHeight
        className="overflow-y-auto rounded-2xl border border-solid border-neutral-200 [&_.ag-root-wrapper]:border-0"
      />
    </div>
  );
};

export default WizardStaff;
